import './styles/index.scss';

import { ApolloProvider } from '@apollo/client/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import { apolloClient } from './api/apollo/client';
import './i18n';
import ThemeProvider from './providers/theme.provider';
import { APP_NAME } from './shared/constants';
import { store } from './store';

const rootEl = document.getElementById('root');
if (rootEl) {
  const helmetContext = {};
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ApolloProvider client={apolloClient}>
          <ThemeProvider>
            <HelmetProvider context={helmetContext}>
              <Helmet
                titleTemplate={`${APP_NAME} / %s`}
                defaultTitle={APP_NAME}
              />
              <App />
            </HelmetProvider>
          </ThemeProvider>
        </ApolloProvider>
      </Provider>
    </React.StrictMode>
  );
}
